import { moment } from '@hotjar/webapp/lib/moment';
import type { Moment } from '@hotjar/webapp/lib/moment';
import type { Clause, DateClause } from '@hotjar/feedback';

function findDateFilterData(filters: Clause[]): DateClause | undefined {
  for (let i = 0; i < filters.length; i += 1) {
    const filter = filters[i];
    if (filter.type === 'date_relative' || filter.type === 'date_absolute') {
      return filter;
    }
  }
  return undefined;
}

function fromDateForDateFilter(dateFilter?: Clause): Moment | null {
  switch (dateFilter?.type) {
    case 'date_relative':
      return moment().subtract(dateFilter.value, dateFilter.unit);
    case 'date_absolute':
      return moment(dateFilter.date_from);
    default:
      return null;
  }
}

function isBeforeCollectingStarted(date: Moment | null) {
  if (!date) return false;
  return date.isBefore('2021-03-08');
}

export function isSupportedDateRange(clauses: Clause[]): boolean {
  return !isBeforeCollectingStarted(fromDateForDateFilter(findDateFilterData(clauses)));
}

export function formatDuration(seconds: number): string {
  const duration = moment.duration({ seconds });
  if (duration.asDays() >= 1) return '>1d';
  return moment.duration(seconds, 'seconds').format('h[h] m[m] s[s]', {
    trim: 'both',
  });
}
